<template>
  <div class="colorful-background end-page-grid">
    <div class="interactive" style="z-index: 300; align-items: center;">
      <div id="btn" v-on:click="restart">双击返回第一页</div>
    </div>

    <div
      class="text"
      style="
        align-items: center;
        justify-content: flex-end;
        margin-bottom: 5vh;
      "
    >
      <span class="middle-font">
        已经是最后一页啦
      </span>
      <!--      <span class="middle-font">-->
      <!--        也是这个学期的最后一页-->
      <!--      </span>-->
      <span class="middle-font">
        你我的故事
      </span>
      <span class="middle-font">
        就在未来继续书写吧
      </span>
      <span> </span>
    </div>

    <div class="img">
      <img src="/sticker/atbotton.png" alt="goodbye!" style="width: 100%;" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'endPage',
  methods: {
    async restart() {
      //todo:嘤嘤嘤 用async函数写一个
      let wait = new Promise((resolve) => {
        setTimeout(() => {
          resolve()
        }, 1000)
      })
      await wait
      this.$emit('re-start')
    },
  },
}
</script>

<style scoped>
.end-page-grid {
  --first-color: var(--eggplant-purple);
  --page-background-color: var(--hdu-school-blue);
  --second-color: var(--hduhelp-blue);
  height: 100%;
  width: 100%;
  display: grid;
  grid-template-columns: 1fr 10fr 1fr;
  grid-template-rows: 5vh repeat(3, minmax(auto, auto)) 5vh;
  grid-template-areas:
    '. .           .'
    '. text        .'
    '. interactive .'
    '. img         .'
    '. .           .';
}

.interactive {
  grid-area: interactive;
  display: flex;
  align-items: center;
  flex-direction: column;
}

/*nav ul {*/
/*  padding: 0;*/
/*  list-style-type: none;*/
/*}*/

#btn {
  color: var(--hduhelp-blue);
  width: 70%;
  height: 5vh;
  font-size: 1.5rem;
  text-align: center;
  line-height: 5vh;
  /*text-transform: uppercase;*/
  /*letter-spacing: 1px;*/
  position: relative;
  transition: 0.3s;
  margin-top: 2vh;
}

#btn::before,
#btn::after {
  width: 100%;
  content: '';
  position: absolute;
  /*width: inherit;*/
  height: inherit;
  top: 0;
  left: 0;
  transition: 0.3s;
}

#btn::before {
  background-color: white;
  z-index: -1;
  box-shadow: 0.2rem 0.2rem 0.5rem rgba(0, 0, 0, 0.2);
}

#btn::after {
  background-color: var(--hduhelp-blue);
  transform: translate(0.5rem, 0.5rem);
  z-index: -2;
}

#btn:hover {
  transform: translate(0.5rem, 0.5rem);
  color: white;
}

#btn:hover::before {
  background-color: var(--hduhelp-blue);
}
#btn:hover::after {
  background-color: white;
  transform: translate(-0.5rem, -0.5rem);
}
</style>
